import { graphql, createPaginationContainer } from 'react-relay';
import CompletedPaymentsComponent from './CompletedPaymentsComponent';
import CompletedPaymentsQuery from '../../../routes/CompletedPaymentsQuery';

export default createPaginationContainer(CompletedPaymentsComponent,
  {
    viewer: graphql`
      fragment CompletedPaymentsContainer_viewer on User
        @argumentDefinitions(
          completed_payments_after: { type: "ISO8601Type" }
          completed_payments_before: { type: "ISO8601Type" }
          count: { type: "Int" }
          cursor: { type: "String" }
        ) {
        s_time_zone
        completed_payments (
          before_time: $completed_payments_before
          after_time: $completed_payments_after
          first: $count
          after: $cursor
        ) @connection(key: "CompletedPayments_completed_payments") {
          edges {
            node {
              ... on CashPayment {
                id
                amount_cents
                amount_currency
                name
                paid_at
                invoice {
                  id
                  title
                  workspaces {
                    edges {
                      node {
                        event {
                          title
                        }
                      }
                    }
                  }
                }
              }
              ... on CheckPayment {
                id
                amount_cents
                amount_currency
                name
                paid_at
                invoice {
                  id
                  title
                  workspaces {
                    edges {
                      node {
                        event {
                          title
                        }
                      }
                    }
                  }
                }
              }
              ... on CustomPayment {
                id
                amount_cents
                amount_currency
                name
                paid_at
                label
                invoice {
                  id
                  title
                  workspaces {
                    edges {
                      node {
                        event {
                          title
                        }
                      }
                    }
                  }
                }
              }
              ... on SquarePayment {
                id
                amount_cents
                amount_currency
                name
                paid_at
                invoice {
                  id
                  title
                  workspaces {
                    edges {
                      node {
                        event {
                          title
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }`
  },
  {
    direction: 'forward',
    getConnectionFromProps(props) {
      return props.viewer && props.viewer.completed_payments;
    },
    getFragmentVariables(prevVars, totalCount) {
      return {
        ...prevVars,
        count: totalCount
      };
    },
    getVariables(props, { count, cursor }, fragmentVariables) {
      return {
        ...fragmentVariables,
        count,
        cursor,

      };
    },
    query: CompletedPaymentsQuery
  }
);



// WEBPACK FOOTER //
// ./webpack/components/Financial/Payments/CompletedPaymentsContainer.js